<template>
  <!-- Top oglasi (pocetna): oznaceni kao top, nisu top kategorija i nisu tezga -->
  <AdsBlock
    :items="items"
    :filter="{ top_ad: 1, top_category: 0, lawyer: 0 }"
    :limit="8"
    title="Top Oglasi"
    dropdown="category"
  />
</template>

<script setup>
import AdsBlock from '~/components/widgets/Advertisement/AdsBlock.vue'

defineProps({
  items: { type: Array, default: () => [] }
})
</script>
